import { useContext } from "react";
import { CaretLeftBold } from "../bold/caret-left-bold";
import { CaretLeftDuotone } from "../duotone/caret-left-duotone";
import { CaretLeftFill } from "../fill/caret-left-fill";
import { CaretLeftLight } from "../light/caret-left-light";
import { CaretLeftRegular } from "../regular/caret-left-regular";
import { CaretLeftThin } from "../thin/caret-left-thin";
import { IconContext } from "./IconContextProvider";
const weightMap = {
  regular: CaretLeftRegular,
  bold: CaretLeftBold,
  duotone: CaretLeftDuotone,
  fill: CaretLeftFill,
  light: CaretLeftLight,
  thin: CaretLeftThin
};
const CaretLeft = (props) => {
  const {
    color: contextColor,
    size: contextSize,
    weight: contextWeight,
    style: contextStyle
  } = useContext(IconContext);
  const {
    color = contextColor ?? "black",
    size = contextSize ?? 24,
    weight = contextWeight ?? "regular",
    style = contextStyle ?? {},
    ...otherProps
  } = props;
  const Component = weightMap[weight];
  return <Component
    color={color}
    size={size}
    weight={weight}
    style={style}
    {...otherProps}
  />;
};
export {
  CaretLeft
};
//# sourceMappingURL=CaretLeft.js.map
